
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/footer-section.kpa`,
      template: `<section class="footer-section">
        <div class="wrapper">
            <img class="hexagon" src="/images/hexagon-gray3-medium.png" alt="Hexagon">
            <img class="hexagon" src="/images/hexagon-gray2-medium.png" alt="Hexagon">
            <div class="footer-top">
                <div>
                    <img src="/images/logo-footer.png" alt="Logo FASE2">

                    <ul class="contact">
                        <li>
                            <a href="tel:+4922194085999">
                                <span><i class="fa-solid fa-phone fa-xl"></i></span>
                                <span>0221 940 859 99</span>
                            </a>
                        </li>

                        <li>
                            <a href="mailto:hallo@fase2.de?subject=Anfrage">
                                <span><i class="fa-solid fa-envelope fa-xl"></i></span>
                                <span>hallo@FASE2.de</span>
                            </a>
                        </li>

                        <li>
                            <a href="https://www.fase2.de">
                                <span><i class="fa-solid fa-globe fa-xl"></i></span>
                                <span>www.FASE2.de</span>
                            </a>
                        </li>

                        <li>
                            <a href="https://www.google.de/maps/place/Reinoldstra%C3%9Fe+6B,+50676+K%C3%B6ln/@50.933193,6.9438329,17z/data=!3m1!4b1!4m6!3m5!1s0x47bf25ab1b4d9cf3:0x125d624dd7250226!8m2!3d50.9331896!4d6.9464078!16s%2Fg%2F11cpf93ghq?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D" target="_blank">
                                <span><i class="fa-solid fa-building fa-xl"></i></span>
                                <span>Reinoldstr. 6b, 50676 Köln</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <h3>Links</h3>
                    <ul class="links">
                        <li>
                            <a href="https://cleanodino.de/" target="_blank">cleanodino</a>
                        </li>

                        <li>
                            <a href="https://www.der-cleanoshop.de/" target="_blank">Der Cleanoshop</a>
                        </li>

                        <li>
                            <a href="https://www.laudani-gmbh.de/" target="_blank">Laudani Bauunternehmung</a>
                        </li>
                    </ul>
                </div>
                <div class="legal">
                    <h3>Rechtliches</h3>
                    <ul>
                        <li>
                            <a href="/impressum">Impressum</a>
                        </li>
                        
                        <li>
                            <a href="/datenschutzerklaerung">Datenschutzerklärung</a>
                        </li>

                        <li>
                            <a href="/agbs">AGB's</a>
                        </li>

                        <li>
                            <a href="/widerrufsbelehrung">Widerrufsbelehrung</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="footer-bottom">
                Copyright {{currentYear}} © <a href="https://www.fase2.de">FASE2</a> | Webdesign: <a href="https://www.bensch.ws" target="_blank">Bensch Web-Services</a>
            </div>
        </div>

        <button class="cookie-banner-button-toggle">
            <i class="fa-solid fa-cookie-bite"></i>
        </button>
    </section>`,
      style: `footer-section .footer-section {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #2c4143;
  color: #ffffff;
  margin: 0;
  padding: 64px 64px 0 64px;
}
footer-section .footer-section .wrapper {
  padding: 0;
}
footer-section .footer-section .wrapper .hexagon {
  position: absolute;
  bottom: -195px;
  right: -150px;
  width: 590px;
  height: auto;
  z-index: 1;
}
footer-section .footer-section .wrapper .hexagon:last-of-type {
  bottom: -90px;
  right: -90px;
  z-index: 2;
}
footer-section .footer-section .wrapper .footer-top {
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: 3;
  gap: 32px;
  padding: 32px 32px;
}
footer-section .footer-section .wrapper .footer-top > div {
  width: calc(33.333% - 32px);
  min-width: 200px;
}
footer-section .footer-section .wrapper .footer-top > div img {
  width: 240px;
  max-width: 100%;
}
footer-section .footer-section .wrapper .footer-top > div h3 {
  color: #ffffff;
}
footer-section .footer-section .wrapper .footer-top > div ul {
  display: flex;
  flex-flow: column nowrap;
  list-style: none;
  padding: 0;
}
footer-section .footer-section .wrapper .footer-top > div ul li {
  padding: 4px 0;
  list-style: none;
}
footer-section .footer-section .wrapper .footer-top > div ul li span {
  color: #ffffff;
}
footer-section .footer-section .wrapper .footer-top > div ul li span:first-of-type {
  display: inline-block;
  width: 32px;
  text-align: center;
}
footer-section .footer-section .wrapper .footer-top > div ul li a {
  color: #ffffff;
  text-decoration: none;
}
footer-section .footer-section .wrapper .footer-top > div ul li a span {
  transition: color 0.3s ease;
}
footer-section .footer-section .wrapper .footer-top > div ul li a:hover {
  color: #64c16c;
}
footer-section .footer-section .wrapper .footer-top > div ul li a:hover span {
  color: #64c16c;
}
footer-section .footer-section .wrapper .footer-top > div ul.contact {
  margin-top: 32px;
  min-width: 236px;
}
footer-section .footer-section .wrapper .footer-top > div:first-of-type {
  min-width: 235px;
}
@media (max-width: 932px) {
  footer-section .footer-section .wrapper .footer-top > div:first-of-type {
    min-width: 50%;
  }
}
footer-section .footer-section .wrapper .footer-bottom {
  position: relative;
  border-top: 3px solid #64c16c;
  padding: 32px 0 84px 0;
  text-align: center;
  font-size: 12px;
  z-index: 3;
}
footer-section .footer-section .wrapper::after {
  content: "";
  position: absolute;
  top: -3px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #64c16c;
  z-index: 3;
}
footer-section .footer-section .cookie-banner-button-toggle {
  position: absolute;
  bottom: 20px;
  left: 50%;
  z-index: 4;
  transform: translateX(-50%);
  transition: color 0.3s ease;
  border: none;
  box-shadow: none;
  font-size: 24px;
  background-color: transparent;
}
footer-section .footer-section .cookie-banner-button-toggle:hover {
  background-color: transparent;
  color: #62bd6a;
}
@media (max-width: 992px) {
  footer-section .footer-section {
    padding: 64px 32px 0 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    methods: {
        currentYear() {
            return new Date().getFullYear();
        }
    },
    events: [
        ['click', '.footer-section .legal a', function (event) {
                event.preventDefault();
                router.navigate(event.target.getAttribute('href'));
            }],
        ['click', '.footer-section .cookie-banner-button-toggle', function (event) {
                event.preventDefault();
                consentManager.openCookieBanner();
            }],
    ]
};
 })()`
    };
  